import { useMemo } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  Legend,
} from 'recharts';
import { aggregateByCoalition } from '../../utils/coalitionLookup';

// Coalition aliases — same coalition under different historical names rolls up.
const LINEAGE = {
  Alliance: 'BN-line',
  'Barisan Nasional': 'BN-line',
  'Pakatan Rakyat': 'PH-line',
  'Pakatan Harapan': 'PH-line',
  'Perikatan Nasional': 'PN-line',
  GPS: 'GPS',
  GRS: 'GRS',
};

const LINE_COLORS = {
  'BN-line': '#000080',
  'PH-line': '#ED1C24',
  'PN-line': '#003153',
  GPS: '#FFD700',
  GRS: '#ADD8E6',
  Others: '#888',
};

const LINE_LABELS = {
  'BN-line': 'Alliance / BN',
  'PH-line': 'PR / PH',
  'PN-line': 'PN',
  GPS: 'GPS',
  GRS: 'GRS',
  Others: 'Others',
};

const SeatTrendStrip = ({ history, activeIndex, onPickYear }) => {
  const data = useMemo(() => {
    return history.map((election, idx) => {
      const groups = aggregateByCoalition(election);
      const row = { year: election.year, _idx: idx, Others: 0 };
      groups.forEach((g) => {
        const lineKey = LINEAGE[g.coalition] || 'Others';
        row[lineKey] = (row[lineKey] || 0) + g.seats;
      });
      return row;
    });
  }, [history]);

  const activeYear = history[activeIndex]?.year;
  const lineKeys = ['BN-line', 'PH-line', 'PN-line', 'GPS', 'GRS', 'Others'];

  return (
    <div className="trend-strip">
      <ResponsiveContainer width="100%" height={140}>
        <LineChart
          data={data}
          margin={{ top: 8, right: 16, bottom: 8, left: 0 }}
          onClick={(e) => {
            if (e && e.activePayload && e.activePayload[0]) {
              const idx = e.activePayload[0].payload._idx;
              onPickYear(idx);
            }
          }}
        >
          <XAxis dataKey="year" tick={{ fontSize: 11 }} interval={0} />
          <YAxis hide />
          <Tooltip
            contentStyle={{ fontSize: 12 }}
            formatter={(value, name) => [value, LINE_LABELS[name] || name]}
          />
          <Legend
            wrapperStyle={{ fontSize: 11 }}
            formatter={(value) => LINE_LABELS[value] || value}
          />
          {lineKeys.map((k) => (
            <Line
              key={k}
              type="monotone"
              dataKey={k}
              stroke={LINE_COLORS[k]}
              strokeWidth={2}
              dot={{ r: 2 }}
              isAnimationActive={false}
            />
          ))}
          {activeYear && (
            <ReferenceLine x={activeYear} stroke="#cb0c13" strokeDasharray="3 3" />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SeatTrendStrip;
